import {
  TOGGLE_SHOW_EDITOR,
  UPDATE_ALL,
  SET_REDIRECT_AFTER_SAVE,
  TOGGLE_VISIBILITY,
  UPDATE_SETTING,
  SET_REDIRECTION_SETTINGS,
  SET_HMT,
  SET_HMT_MUTATION
} from "./constants.js";

const regex = /^(settings\/)/;

const _TOGGLE_SHOW_EDITOR = TOGGLE_SHOW_EDITOR.replace(regex, "");
const _UPDATE_ALL = UPDATE_ALL.replace(regex, "");
const _SET_REDIRECT_AFTER_SAVE = SET_REDIRECT_AFTER_SAVE.replace(regex, "");
const _SET_HMT = SET_HMT.replace(regex, "");

export default {
  [_TOGGLE_SHOW_EDITOR]({ commit }) {
    commit(TOGGLE_VISIBILITY);
  },
  [_UPDATE_ALL]({ commit }, settings) {
    commit(UPDATE_SETTING, settings);
  },
  [_SET_REDIRECT_AFTER_SAVE](
    { commit },
    { filename, customerId, redirectUrl, callbackUrl }
  ) {
    commit(SET_REDIRECTION_SETTINGS, { filename, customerId, redirectUrl, callbackUrl });
  },
  [_SET_HMT]({ commit }, newHmtSettings) {
    commit(SET_HMT_MUTATION, newHmtSettings);
  }
};
